module.exports = __webpack_public_path__ + "static/media/1POLICY1.a2b81f44.jpg";